import { render, staticRenderFns } from "./alarmMessage.vue?vue&type=template&id=36649dd0"
import script from "./alarmMessage.vue?vue&type=script&lang=js"
export * from "./alarmMessage.vue?vue&type=script&lang=js"
import style0 from "./alarmMessage.vue?vue&type=style&index=0&id=36649dd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports